import PageInitializer from './libs/page-initializer';
import { EVENT_READY } from './constants/event';
import './components/cart-remove-button';
import './components/cart-counter';
import './components/cart';
import './components/cart-item';
import './components/global-nav';
import './components/global-nav-toggle';

PageInitializer.getInstance()
  .ready()
  .then(() => {
    const body = document.body;
    body.classList.add('is-loaded');

    document.dispatchEvent(new Event(EVENT_READY));
  });
